/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EdictSelectionRequest } from './EdictSelectionRequest';
import {
    EdictSelectionRequestFromJSON,
    EdictSelectionRequestFromJSONTyped,
    EdictSelectionRequestToJSON,
    EdictSelectionRequestToJSONTyped,
} from './EdictSelectionRequest';

/**
 * 
 * @export
 * @interface CreateEdictRecordsRequest
 */
export interface CreateEdictRecordsRequest {
    /**
     * 
     * @type {Array<EdictSelectionRequest>}
     * @memberof CreateEdictRecordsRequest
     */
    entries: Array<EdictSelectionRequest>;
}

/**
 * Check if a given object implements the CreateEdictRecordsRequest interface.
 */
export function instanceOfCreateEdictRecordsRequest(value: object): value is CreateEdictRecordsRequest {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function CreateEdictRecordsRequestFromJSON(json: any): CreateEdictRecordsRequest {
    return CreateEdictRecordsRequestFromJSONTyped(json, false);
}

export function CreateEdictRecordsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEdictRecordsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(EdictSelectionRequestFromJSON)),
    };
}

export function CreateEdictRecordsRequestToJSON(json: any): CreateEdictRecordsRequest {
    return CreateEdictRecordsRequestToJSONTyped(json, false);
}

export function CreateEdictRecordsRequestToJSONTyped(value?: CreateEdictRecordsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entries': ((value['entries'] as Array<any>).map(EdictSelectionRequestToJSON)),
    };
}

